import HTTP from "../http";
import AddressesHelper from "@/api/helpers/addresses";
import Jsona from "jsona";

const dataFormatter = new Jsona();

const PAGE_SIZE = 25;

export default {
  async index(page) {
    try {
      let response = await HTTP.normal.get(
        `/addresses?include=district.city.state.country,district.pricing&page[number]=${page}&page[size]=${PAGE_SIZE}`
      );
      return dataFormatter.deserialize(response.data);
    } catch (e) {
      throw e;
    }
  },
  async destroy(id) {
    try {
      await HTTP.normal.delete(`/addresses/${id}`, id);
    } catch (e) {
      throw e;
    }
  },

  async create(payload) {
    try {
      let address = await HTTP.normal.post(
        "/addresses",
        AddressesHelper.buildRequestBody(payload)
      );
      return dataFormatter.deserialize(address.data);
    } catch (e) {
      throw e;
    }
  },

  async update(payload) {
    try {
      let data = AddressesHelper.buildUpdateRequestBody(payload);
      await HTTP.normal.patch(`/addresses/${payload.id}`, data);
    } catch (e) {
      throw "Ocorreu um erro ao alterar o endereço!";
    }
  },

  async getCities() {
    try {
      let {
        data: { included }
      } = await HTTP.normal.get("/addresses?include=district.city");
      return included ? included.filter(el => el.type === "cities") : [];
    } catch (e) {
      throw "Ocorreu um erro ao buscar as cidades!";
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/addresses.js